import { Sponsor } from "./store";

// Given that the sponsor
// has had the bill sent already, is sending a payment notification allowed?
export function isNotificationAllowed(sponsor: Sponsor): boolean {
    if (sponsor.shouldPay == 0)
        return false;

    if (sponsor.numNotificationsSent >= 2)
        return false;

    let lastSentOn = new Date(
        sponsor.notificationSentOn ? sponsor.notificationSentOn : sponsor.billSentOn
    ).valueOf();

    let now = Date.now();
    let daysSinceLastReminder = (now - lastSentOn) / 1000 / 3600 / 24;
    
    let notificationThresholdDays = sponsor.notificationSentOn ? 21 : 35;

    return daysSinceLastReminder >= notificationThresholdDays;
}

export function isInvitationAllowed(sponsor: Sponsor): boolean {
    if (!sponsor.invitedOn)
        return true;

    let now = Date.now();
    let lastInvitedOn = new Date(sponsor.invitedOn).valueOf();
    let daysSinceLastInvite = (now - lastInvitedOn) / 1000 / 3600 / 24;

    return daysSinceLastInvite >= 21;
}

export function getQueryStringArgs(): { [key: string]: string } {
    let args = {};

    for (let arg of location.search.substr(1).split(/&/g))
    {
        let parts = arg.split(/=/, 2);
        args[parts[0]] = parts[1] ? decodeURIComponent(parts[1].replace(/\+/g, " ")) : "";
    }

    return args;
}